import { ApiRoute } from "PFCore/utilities/routes";

export const fetchCurrentProfile = async () =>
  await $.ajax({
    url: ApiRoute("/api/me"),
    api_version: 2
  });
